import { render, staticRenderFns } from "./PullUpComponent.vue?vue&type=template&id=5fe0bd32&scoped=true&"
import script from "./PullUpComponent.vue?vue&type=script&lang=js&"
export * from "./PullUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./PullUpComponent.vue?vue&type=style&index=0&id=5fe0bd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0bd32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
